module.exports = __webpack_public_path__ + "media/images/pension_mark-a0f69af99bbb240fe674cfe4c6257226.png";